<template>
  <Header />
  <Navi />
  <router-view />
  <Footer v-if="!$store.state.is_loading" />
  <!-- <transition name="fade">
        <div class="app-cover" ref="cover" v-if="is_show_cover">
            <video autoplay muted webkit-playsinline playsinline ref="video">
                <source :src="video_url" type="video/mp4">
            </video>
        </div>
    </transition> -->

  <transition name="fade">
    <div class="app-time-cover" ref="time" v-if="is_show_time_cover">
      <svg-icon name="home-logo" />
    </div>
  </transition>
</template>
<script>
import Header from '@/components/Header.vue';
import Navi from '@/components/Navi.vue';
import Footer from '@/components/Footer.vue';

export default {
  components: {
    Header,
    Navi,
    Footer,
  },

  data() {
    return {
      is_show_cover: true,
      is_show_time_cover: false,
      video_url: '',
      inactivity_timeout: null,
    };
  },

  watch: {
    '$route.params': {
      handler(params) {
        this.updateClass(params);
      },

      immediate: true,
    },
  },

  methods: {
    updateClass(params) {
      let body_class = '';
      if (this.$route.name !== 'home') body_class = 'not-home ';
      if (typeof this.$route.name === 'string') body_class = body_class + 'page-' + this.$route.name;
      if (params.slug) body_class = body_class + ' slug-' + params.slug;
      if (params.category) body_class = body_class + ' category-' + params.category;
      document.documentElement.classList.remove('disabled-scroll');

      document.body.className = body_class;
      this.$store.state.show_menus = false;

      if (this.$store.state.disabled_scroll) {
        this.$store.state.disabled_scroll = false;
      } else {
        // 检查是否是浏览器后退/前进操作
        const navigationEntries = performance.getEntriesByType('navigation');
        const isBackForward = navigationEntries.length > 0 && 
                             navigationEntries[0].type === 'back_forward';
        
        // 只有在非后退/前进操作时才滚动到顶部
        if (!isBackForward) {
          window.scrollTo(0, 0);
        }
      }
    },

    resetInactivityTimer() {
      // console.log(this.inactivity_timeout)
      if (this.inactivity_timeout) {
        clearTimeout(this.inactivity_timeout);
      }
      this.is_show_time_cover = false;
      this.inactivity_timeout = setTimeout(() => {
        this.is_show_time_cover = true;
      }, 60000); // 1 minute
    },
  },

  mounted() {
    this.resetInactivityTimer();
    window.addEventListener('mousemove', this.resetInactivityTimer);
    window.addEventListener('mousedown', this.resetInactivityTimer);
    window.addEventListener('scroll', this.resetInactivityTimer);
    window.addEventListener('keydown', this.resetInactivityTimer);
    this.$store.state.site_name = window.globals.name;
    this.$store.state.site_description = window.globals.description;
    this.video_url = window.globals.cover_video;
    this.$nextTick(() => {
      if (this.$refs.video)
        this.$refs.video.addEventListener('ended', () => {
          this.is_show_cover = false;
        });
    });
  },

  beforeDestroy() {
    window.removeEventListener('mousemove', this.resetInactivityTimer);
    window.removeEventListener('mousedown', this.resetInactivityTimer);
    window.removeEventListener('scroll', this.resetInactivityTimer);
    window.removeEventListener('keydown', this.resetInactivityTimer);
  },
};
</script>

<style lang="scss">
@use 'sass:math';
@import '@/assets/sass/fonts';
@import '@/assets/sass/reset';

/********* Base */
$padding: 1rem;
// $inner-width: 1780px;
$inner-width: 1780px;

// remove scroll bar
// ::-webkit-scrollbar {
//   display: none;
// }

:root {
  --inner-width: 90rem;
  --max-width: 1780px;
  --content-width: 80rem;
  --base-size: 1.2rem;
  --dropdown-size: 1.4rem;
  --medium-size: 1.6rem;
  --large-size: 2rem;
  --small-size: 1rem;
  --extra-small-size: 0.8rem;
  --title-size: 3rem;
  --big-size: 4.3rem;
  --letter-spacing: 0rem;
  --carousel-size: 1.9rem;
  // --big-size: 3rem;
  // --large-size: 4rem;

  --padding-25: #{math.div($padding, 4)};
  --padding-50: #{math.div($padding, 2)};
  --padding: #{$padding};
  --padding-x2: #{$padding * 2};
  --padding-x3: #{$padding * 3};
  --padding-x4: #{$padding * 4};
  --padding-x5: #{$padding * 5};
  --padding-x6: #{$padding * 6};
  --padding-x7: #{$padding * 7};
  --padding-x8: #{$padding * 8};
  --padding-x9: #{$padding * 9};
  --padding-x10: #{$padding * 10};
  --padding-x18: #{$padding * 18};

  --padding-50-neg: -#{math.div($padding, 2)};
  --padding-neg: -#{$padding};

  // --padding-x5: #{$padding * 5};
  // --padding-x6: #{$padding * 6};

  --font: 'Eames', 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --font2: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --font-color: #000000;
  --bg-color: #f9f9f6;
  --gray: #898989;

  --blue: #a0f5e1;
  --red: #ff4100;
  --yellow: #cba85f;

  // --purple: #C06BE8;
}

// @media only screen and (max-width: 800px) {
//     $padding: 2rem;
// }

input,
text,
keygen,
select,
button,
meter,
progress,
pre {
  font-family: var(--font);
}

/********* Links */
// :focus {
//     outline: 3px dashed var(--font-color);
// }

a,
a:visited,
a:active {
  color: var(--font-color);
  // outline: none;
  text-decoration: none;
  // transition: color .2s;
}

*[tabindex='0'],
a:focus {
  // outline-width: 3px;
  // outline-style: dashed;
  outline-color: black;
}

a:hover {
  text-decoration: none;
  color: var(--font-color);
}

// input:-webkit-autofill {
//     box-shadow: 0 0 0px 1000px white inset;
// }

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@font-feature-values "Eames" {
  @styleset {
    alt-a: 1;
    alt-g: 2;
  }

  @stylistic {
    alternates: 1;
  }
}

h1,
h2,
h3,
h4,
h5,
h6,
strong,
span,
b,
figcaption,
p {
  font-weight: normal;
  font-variant-numeric: normal;
  font-variant-numeric: lining-nums;
}

i,
em {
  font-style: italic;
  font-family: var(--font);
  font-variant-numeric: normal;
  font-variant-numeric: lining-nums;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='date']::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}

::-webkit-input-placeholder {
  color: var(--gray);
}

::-moz-placeholder {
  color: var(--gray);
}

:-ms-input-placeholder {
  color: var(--gray);
}

:-moz-placeholder {
  color: var(--gray);
}

::-moz-selection {
  background: var(--gray);
  text-shadow: none;
  color: white;
}

::selection {
  background: var(--gray);
  text-shadow: none;
  color: white;
}

.mobile-item {
  display: none;
}

.desktop-item {
  display: block;
}



html {
  -webkit-overflow-scrolling: touch;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  font-size: 1vw;
  overflow: auto;
  text-rendering: optimizelegibility;
  background-color: var(--bg-color);
  
  @media screen and (min-width: $inner-width) {
    font-size: 17.5px;
  }

  &.disabled-scroll {
    overflow: hidden !important;
  }

  // &::-webkit-scrollbar {
  //   width: 8px;
  //   height: 8px;
  // }

  // &::-webkit-scrollbar-track {
  //   border-radius: 3px;
  // }

  // &::-webkit-scrollbar-thumb {
  //   border-radius: 4px;
  //   border: 2px solid transparent;
  //   background-clip: content-box;
  //   background-color: transparent;
  //   transition: 0.2s background-color ease;
  // }

  // &:hover::-webkit-scrollbar-thumb {
  //   background-color: red;
  // }
}

html body {
  font-family: var(--font);
  color: var(--font-color);
  background-color: var(--bg-color);
  font-feature-settings: 'ss02';

  /* Font smoothing */
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: var(--base-size);
  min-height: 100vh;
  line-height: 1.35;
  
}

// Syntax for old style tabular numbers
p {
  font-variant-numeric: lining-nums;
}

em {
  font-style: italic;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.wrap {
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 100%;
}

.inner {
  width: 100%;
  max-width: var(--max-width);
  margin-left: auto;
  margin-right: auto;
  padding-left: var(--padding);
  padding-right: var(--padding);
  box-sizing: border-box;
}

.cols {
  display: flex;
  flex-wrap: wrap;
  margin-left: var(--padding-neg);
  margin-right: var(--padding-neg);

  & > * {
    padding-left: var(--padding);
    padding-right: var(--padding);
    box-sizing: border-box;
  }

  &-2 {
    & > * {
      width: 50%;
    }
  }

  &-3 {
    & > * {
      width: 33.33%;
    }
  }

  &-4 {
    & > * {
      width: 25%;
    }
  }

  &-5 {
    & > * {
      width: 20%;
    }
  }

  &-6 {
    & > * {
      width: 16.66%;
    }
  }
}


.related-items {
  padding: 0 var(--padding-x2);
  display: flex;
  gap: var(--padding-x2);

  @media screen and (max-width: 780px) {
    padding: 0 var(--padding);
    flex-direction: column;
    gap: 0;
  }
}
/*
.app-cover {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 999999;
  background: var(--blue);

  video {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
*/

.app-time-cover {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 999999;
  background: rgba(#f9f9f6, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 70%;
    height: 70%;
    display: block;
    fill: var(--red);
  }
}

.img-wrap {
  position: relative;
  width: 100%;

  &::before {
    display: block;
    content: '';
  }

  img {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  &.r-3x4 {
    &::before {
      padding-bottom: 75%;
    }
  }

  &.r-4x3 {
    &::before {
      padding-bottom: 150%;
    }
  }

  &.r-1x1 {
    &::before {
      padding-bottom: 100%;
    }
  }
}

.page-header {
  margin: 0 auto var(--padding-x6);
  text-align: center;

  h1 {
    margin: var(--padding) auto;
    max-width: 50rem;
    font-size: var(--large-size);
    line-height: 1.1;
  }

  h2 {
    font-size: var(--large-size);
    text-transform: uppercase;
    padding-top: var(--padding-x6);
  }

  @media screen and (max-width: 780px) {
    margin-bottom: var(--padding-x2);

    h2 {
      padding-top: var(--padding-x2);
    }
  }
}

.more {
  display: block;
  height: 3.2rem;
  width: 3.2rem;
  border: 1px solid var(--red);
  position: relative;
  transition: 0.3s all ease-in-out;
  overflow: hidden;
  margin: 0 auto;
  background-color: white;

  i {
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s all ease-in-out;
    opacity: 1;

    svg {
      height: 1rem;
      width: 1rem;
      display: block;
      fill: var(--red);
      transform: translate(0%, 0);
    }

    &:nth-child(2) {
      transform: translate(-50%, 0);
      opacity: 0;

      svg {
        fill: white;
      }
    }
  }

  &:hover {
    background-color: var(--red);

    i {
      &:nth-child(1) {
        transform: translate(50%, 0);
        opacity: 0;
      }

      &:nth-child(2) {
        transform: translate(0%, 0);
        opacity: 1;
      }
    }
  }
}

.footnotes {
  #footnote-label {
    display: none;
  }

  ol {
    margin: var(--padding) var(--padding-50-neg) !important;
    display: flex;
    flex-wrap: wrap;

    li {
      width: 55%;
      font-size: var(--small-size);
      box-sizing: border-box;
      padding: 0 var(--padding) var(--padding);
      list-style: none !important;
      position: relative;
      line-height: 1.5;

      p {
        margin: 0;
        padding: 0;
      }

      sup {
        position: absolute;
        top: 0.7rem;
        left: -0.5rem;
        font-size: var(--small-size);

        @media only screen and (max-width: 780px) {
          top: 0.85rem;
        }
      }
    }
  }
}

.pswp__zoom-wrap img {
  object-fit: contain !important;
}

@media only screen and (max-width: 780px) {
  $padding: 2.5rem;

  :root {
    --inner-width: auto;
    --content-width: auto;
    --base-size: 2rem;
    --medium-size: 2.2rem;
    --large-size: 3rem;
    --small-size: 1.4rem;
    --extra-small-size: 0.8rem;
    --title-size: 3rem;
    --big-size: 4.3rem;
    --letter-spacing: 0rem;
    // --big-size: 3rem;
    // --large-size: 4rem;

    --padding-25: #{math.div($padding, 4)};
    --padding-50: #{math.div($padding, 2)};
    --padding: #{$padding};
    --padding-x2: #{$padding * 2};
    --padding-x3: #{$padding * 3};
    --padding-x4: #{$padding * 4};
    --padding-x5: #{$padding * 5};
    --padding-x6: #{$padding * 6};
    --padding-x7: #{$padding * 7};
    --padding-x8: #{$padding * 8};
    --padding-x9: #{$padding * 9};
    --padding-x10: #{$padding * 10};
    --padding-x18: #{$padding * 18};

    --padding-50-neg: -#{math.div($padding, 2)};
    --padding-neg: -#{$padding};
  }

  html {
    font-size: 2vw;
  }

  .cols {
    margin-left: var(--padding-50-neg);
    margin-right: var(--padding-50-neg);

    & > * {
      padding-left: var(--padding-50);
      padding-right: var(--padding-50);
      box-sizing: border-box;
    }

    &-2 {
      & > * {
        width: 100%;
      }
    }

    &-3 {
      & > * {
        width: 100%;
      }
    }

    &-4 {
      & > * {
        width: 50%;
      }
    }

    &-5 {
      & > * {
        width: 50%;
      }
    }

    &-6 {
      & > * {
        width: 50%;
      }
    }
  }
}

body.page-new .wrap {
  overflow: hidden;

  .ui-gallery,
  .ui-gallery .swiper {
    overflow: visible;
  }
}
</style>
